import { jsx as t, jsxs as i } from "react/jsx-runtime";
import "react";
var f = (l) => /* @__PURE__ */ i("svg", {
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...l,
  children: [
    /* @__PURE__ */ t("rect", {
      width: 20,
      height: 20,
      fill: "#F5F5F5"
    }),
    /* @__PURE__ */ t("rect", {
      width: 1876,
      height: 988,
      transform: "translate(-1794 -588)",
      fill: "white"
    }),
    /* @__PURE__ */ t("path", {
      d: "M20 3.3335H0V16.667H20V3.3335Z",
      fill: "#91DC5A"
    }),
    /* @__PURE__ */ t("path", {
      d: "M20 0H0V20H20V0Z",
      fill: "#F0F0F0"
    }),
    /* @__PURE__ */ t("path", {
      d: "M20 0H0V3.35086H20V0Z",
      fill: "#0052B4"
    }),
    /* @__PURE__ */ t("path", {
      d: "M20 16.65H0V20H20V16.65Z",
      fill: "#0052B4"
    }),
    /* @__PURE__ */ t("path", {
      d: "M20 4.68042H0V15.32H20V4.68042Z",
      fill: "#D80027"
    }),
    /* @__PURE__ */ t("path", {
      d: "M6.25 13.75C8.32107 13.75 10 12.0711 10 10C10 7.92893 8.32107 6.25 6.25 6.25C4.17893 6.25 2.5 7.92893 2.5 10C2.5 12.0711 4.17893 13.75 6.25 13.75Z",
      fill: "#F0F0F0"
    }),
    /* @__PURE__ */ t("path", {
      d: "M6.2502 6.25024L7.09164 8.83974H9.81879L7.61164 10.4403L8.45957 13.0375L6.2502 11.4294L4.04414 13.0345L4.88875 10.4403L2.68359 8.83974H5.40875L6.2502 6.25024Z",
      fill: "#D80027"
    })
  ]
});
export {
  f as default
};
